import { IDateRangeByNumberWithType } from '@/interfaces/general/IDateRangeByString.ts';
import { IModuleChartConfig } from '@/interfaces/powerMarkets/charts/IModuleChartConfig.ts';

export function getPlantChartDate (
    config: IModuleChartConfig,
    fromDate?: Date,
    toDate?: Date,
): IDateRangeByNumberWithType {
    if (fromDate || toDate) {
        const from = fromDate ?? toDate;
        const to = toDate ?? fromDate;

        return {
            from: { type: 'date', value: from?.getTime() ?? 0 },
            to: { type: 'date', value: to?.getTime() ?? 0 },
        };
    }

    const recentHour = config.data.defaultTimeType === 'Hours';

    if (config.data.daysAfter === 0 && config.data.daysBefore === 0) {
        return {
            from: { type: 'date', value: 0 },
            to: { type: 'date', value: 0 },
        };
    }

    if (recentHour) {
        return {
            recentHour,
            from: { type: 'dynamicHours', value: config.data.daysBefore || 0 },
            to: { type: 'dynamicHours', value: config.data.daysAfter || 0 },
            fromHours: config.data.daysBefore || 0,
            toHours: config.data.daysAfter || 0,
        };
    }

    return {
        recentHour,
        from: { type: 'dynamic', value: config.data.daysBefore || 0 },
        to: { type: 'dynamic', value: config.data.daysAfter || 0 },
    };
}
